module.exports = __webpack_public_path__ + "img/cata_v2.39151942.png";